import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages';
import style from './print-barcode-link.module.less';

const scanToPrintBarcodesUrl = '//s3.amazonaws.com/downloads.shipstation.com/ScanToPrintBarcodes.pdf';

export const PrintBarcodeLink = ({ className = '', inactive = false }) => {
  const classes = classnames(className, style['print-barcode-link'], {
    [style.dark]: inactive,
  });

  return (
    <a className={classes} href={scanToPrintBarcodesUrl} rel='noopener noreferrer' target='_blank'>
      <FormattedMessage {...messages.printBarcodeSheet} />
    </a>
  );
};

PrintBarcodeLink.propTypes = {
  className: PropTypes.string,
  inactive: PropTypes.bool,
};
